import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { useLang } from "../LanguageContext";
import { waLink } from "../restaurant.config";

export default function WhatsAppFloat() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      data-testid="whatsapp-float-btn"
      href={waLink(t.contatti.prefill)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Reserve on WhatsApp"
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#B85532] text-white px-5 py-4 shadow-xl rounded-full transition-all duration-500 hover:scale-105 hover:bg-[#a04825] ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <MessageCircle className="w-5 h-5" strokeWidth={1.6} />
      <span className="hidden md:inline text-xs uppercase tracking-[0.22em]">
        {t.nav.prenota}
      </span>
    </a>
  );
}
